import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';

import {
  useStoreSelector as useSelector,
  useStoreDispatch as useDispatch,
} from '@marketmuse/data-state/hooks';

import * as miscActions from '../../../actions/miscActions';

const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const POWER_UP_PAGE_ACTIVE = 'POWER_UP_PAGE_ACTIVE';

const PowerUps = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const site = useSelector(state => state.filter.site);

  const url = useMemo(() => {
    const org = user.org;
    const params = {
      userId: user?.id,
      userEmail: user?.email,
      userSFDCId: user?.sfdcContactId,
      userFullName: user?.fullName,
      userFirstName: user?.firstName,
      userLastName: user?.lastName,
      siteDomain: site?.domain,
      siteId: site?.id,
      orgId: org?.id,
      orgName: org?.name,
      orgSFDCId: org.sfdcAccountId,
    };
    const cleanParams = Object.entries(params).reduce((acc, entry) => {
      const [key, value] = entry;
      if (value) {
        return { ...acc, [key]: value };
      } else {
        return acc;
      }
    }, {});
    const queryParams = new URLSearchParams(cleanParams).toString();

    const pageSource = 'https://www.marketmuse.com/power-ups-page/';
    return `${pageSource}?${queryParams}`;
  }, [user, site]);

  useEffect(() => {
    dispatch(miscActions.setSimple({ key: POWER_UP_PAGE_ACTIVE, value: true }));

    return () => {
      dispatch(
        miscActions.setSimple({ key: POWER_UP_PAGE_ACTIVE, value: false }),
      );
    };
  }, [dispatch]);

  return (
    <Wrapper showOverflow={false}>
      <Iframe title="Power ups" src={url} />
    </Wrapper>
  );
};

export const Component = PowerUps;

export default PowerUps;
